let Interactions = {
    bots: {
        "InsightsBotDev": {
            "name": "InsightsBotDev",
            "alias": "$LATEST",
            "region": "us-west-2"
        }
    }
};
export default Interactions;